<template>
  <b-card class="mb-0 w-100 h-100">
    <div class="d-flex justify-content-between align-items-center mb-1">
      <h5 class="mb-0"> {{ $t('ia.reimagine.sourceImage') }}</h5>
      <p class="mb-0 avenir-medium cursor-pointer text-blue" @click="startAgain()">{{ $t('ia.reimagine.startOver') }}</p>
    </div>
    <input-drag-and-drop-file 
      :data="{
        extensions_allowed: '.jpg, .jpeg, .png', 
        icon: {type: 'b-icon', name: 'file-earmark-image'}, 
        title: $t('ia.reimagine.uploadPhoto'), 
      }"
      @file_loaded="fileLoaded"
      class="input-drag-and-drop-file mb-2"
      v-if="!previewImage()"
    ></input-drag-and-drop-file>
    <div v-else class="container-blob-aspect-ratio-select mb-2">
      <div class="d-flex align-items-center justify-content-center h-min-300">
        <b-img :src="previewImage()" class="img-inner" :style="`aspect-ratio: ${options_image.aspect_ratio};`"></b-img>
        <canvas ref="canvas_preview_reimagine" class="d-none"></canvas>
      </div>
    </div>

    <!-- <div class="container-controls-aspect-ratio">
      <p class="avenir-medium text-center mt-2">ASPECT RATIO ({{ get_correct_label_aspect_ratio }})</p>
      <div class="d-flex align-items-center justify-content-between">
        <b-icon icon="aspect-ratio" font-scale="1.5"></b-icon>
        <b-form-input id="range-2" disabled v-model="value_range_aspect" type="range" min="0" max="6" step="1" class="px-05"></b-form-input>
        <b-icon icon="aspect-ratio" class="rotate-icon" font-scale="1.5"></b-icon>
      </div>
    </div> -->
  </b-card>
</template>

<script>

import { 
  BCard,
  BImg,
  // BFormInput,
} from 'bootstrap-vue';
import { getAssetUrl, isUrl } from '@/libs/utils/urls';

export default {
  name: 'siderRightReimagine',
  components: {
    BCard,
    BImg,
    // BFormInput,
    inputDragAndDropFile: () => import('@/views/components/inputs/inputDragAndDropFile.vue')
  },
  props: {
    history_images: {
      type: Object,
    },
    options_image: {
      type: Object,
    },
    setting_selected: {
      type: Object,
    },
  },
  data() {
    return {
      is_open: {},
      collapse_full_prompt: false,
      preview: null,
      value_range_aspect: 3
    }
  },
  computed: {
    get_correct_label_aspect_ratio() {
      const splitted = this.options_image.aspect_ratio.split('/');
      return `${splitted[0]}:${splitted[1]}`
    },
  },
  methods: {
    startAgain() {
      this.preview = null;
      this.setting_selected.file = null;
      if (Object.keys(this.history_images).length > 0) { 
        this.$emit('start_again');
        this.$router.push({ name: 'brandme_AI', params: { section: 'image', category: 'reimagine'}});
      }      
    },
    previewImage() {
      if (this.preview) return this.preview;
      if (this.history_images?.data?.origin_image) return isUrl(this.history_images.data.origin_image) ? this.history_images.data.origin_image : getAssetUrl(this.history_images.data.origin_image);
      return null;
    } ,
    fileLoaded(file) {
      this.preview = URL.createObjectURL(file);
      this.setting_selected.file = file;
    },
  },
  watch: {
    value_range_aspect(val) {
      const aspects_avaible = ['16/9', '5/4', '4/3', '1/1', '3/4', '4/5', '9/16'];
      this.options_image.aspect_ratio = aspects_avaible[parseInt(val)] || '1/1';
    }
  }
}
</script>

<style lang="scss" scoped>
.input-drag-and-drop-file {
  height: 150px !important;
}
.container-controls-aspect-ratio {
  .px-05 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .rotate-icon {
    transform: rotate(90deg);
  }
}
.container-blob-aspect-ratio-select {
  height: 150px;
  background-color: #dee2e6;
  border-radius: 0.4rem;
  display: flex;
  justify-content: center;
  .h-min-300 {
    max-height: 300px;
  }
  .img-inner {
    width: 100%;
    margin: 0 auto;
    height: 100%;
    vertical-align: middle;
    object-fit: cover;
  }
}
.container-blob {
  width: 100%;
  height: 120px;
  background-color: #DEE2E6;
  border-radius: 0.7em;
  position: relative;
  
  .img-blob {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
